import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Account", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Account ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Payment Terms", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Payment Terms ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Code - ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Description - ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Customer No", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Customer No ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Deposit Required", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Deposit Required ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Invoice No", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Invoice No ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Net Days from Invoice Date", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Net Days from Invoice Date ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Invoice Date", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Invoice Date ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Reason for Delinquency", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Reason for Delinquency ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Invoice Amount", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Invoice Amount ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Reason for Bad Debt Write-off", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Reason for Bad Debt Write-off ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Balance Due", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Balance Due ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Collector Code", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Collector Code ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "HB Order No", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" HB Order No ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "HB Customer PO No", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" HB Customer PO No ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "3rd Party Collector", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 3rd Party Collector ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_filled = _resolveComponent("info-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_1,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_2
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.account), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_3,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_4
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _hoisted_5,
                  _createElementVNode("code", null, _toDisplayString(_ctx.customerTermsCode), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createElementVNode("code", null, _toDisplayString(_ctx.customerTermsDesc), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_7,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.customerNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_9,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.depositRequired), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_11,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_12
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.invoiceNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_13,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.netDaysFromInvoiceDate), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_15,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_16
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.moment.utc(_ctx.invoiceDate).format("MM-DD-YYYY")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "space-between",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, [
                        _hoisted_17,
                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                          content: _withCtx(() => [
                            _hoisted_18
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              class: "el-text__grey",
                              style: {"font-size":"small"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_info_filled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.reasonForDelinquencyValue,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reasonForDelinquencyValue) = $event)),
                        onChange: _ctx.updateInvoice
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasonForDelinquencyDropdownResponse, (option, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: option.value,
                              value: option.key
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createVNode(_component_el_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_19,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.invoiceAmount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "space-between",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, [
                        _hoisted_21,
                        _createVNode(_component_el_tooltip, { placement: "right" }, {
                          content: _withCtx(() => [
                            _hoisted_22
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              class: "el-text__grey",
                              style: {"font-size":"small"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_info_filled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.reasonForBadDebtWriteOffValue,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reasonForBadDebtWriteOffValue) = $event)),
                        onBlur: _ctx.updateInvoice
                      }, null, 8, ["modelValue", "onBlur"])
                    ]),
                    _createVNode(_component_el_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_23,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_24
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.balanceDue), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_25,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_26
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.collectorCode), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_27,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_28
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.hbOrderNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_29,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_30
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.hbCustomerPoNo), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _hoisted_31,
                  _createVNode(_component_el_tooltip, { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_32
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-text__grey",
                        style: {"font-size":"small"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_filled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.thirdPartyCollector), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}